"use client";

import dynamic from "next/dynamic";

import { useFeatureFlagsState } from "@/hooks/useFeatureFlags";
import { useAuthStore } from "@/shared/model/auth-store";

import type { ToolMiniViews } from "./tool-mini-host";

// Код кнопки и колеса скачивается только тем, кому кнопка положена (KAN-1319).
const ToolWheelLauncher = dynamic(
  () => import("./tool-wheel-launcher").then((m) => m.ToolWheelLauncher),
  { ssr: false },
);

/**
 * Проверка входа и флага `tools` — здесь, в статическом коде, а не внутри
 * ленивого компонента: иначе, чтобы решить «кнопку не показывать», гость
 * сначала скачивал бы её код (17 КБ на каждой странице, KAN-1319).
 */
export function ToolWheelGate({ miniViews }: { miniViews: ToolMiniViews }) {
  const isAuthenticated = useAuthStore((s) => s.isAuthenticated);
  const { flags } = useFeatureFlagsState();
  if (!isAuthenticated || !flags.tools) return null;
  return <ToolWheelLauncher miniViews={miniViews} />;
}
